import { INTERIOR_AREA_TYPES } from "../../config/areas";
import { calculateDoorPanelArea, calculateWindowFrameArea } from "./baseArea";
import {
  calculateTotalArea as calculateTotalRoomArea,
  castStringPropsToNumbers as castStringRoomPropsToNumbers,
} from "./roomArea";
import {
  calculateTotalArea as calculateTotalWallArea,
  castStringPropsToNumbers as castStringWallPropsToNumbers,
} from "./wallArea";

export const isRoom = (area) => {
  return area.type !== INTERIOR_AREA_TYPES.CUSTOM_WALL;
};

export const isBathroom = (area) => {
  return area.type === INTERIOR_AREA_TYPES.BATHROOM;
};

export const calculateTotalArea = (area) => {
  return isRoom(area)
    ? calculateTotalRoomArea(area)
    : calculateTotalWallArea(area);
};

export const calculateTrimArea = (area) => {
  return calculateWindowFrameArea(area) + calculateDoorPanelArea(area);
};

export const castStringPropsToNumbers = (area) => {
  return isRoom(area)
    ? castStringRoomPropsToNumbers(area)
    : castStringWallPropsToNumbers(area);
};

export const calculateCeilingArea = (area) => {
  return isRoom(area) ? area.width * area.length : 0;
};
